import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {

  progress!: number;
  interval!: any;

  constructor() { }

  start(): void {
    this.clear();
    this.interval = setInterval(() => {
      this.progress += this.progress < 75 ? 0.5 : 0.25;
      if (this.progress >= 100) {
        this.stop();
      }
    }, 50);
  }

  clear(): void {
    this.progress = 0;
    this.stop();
  }

  private stop(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

}
